import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
// -- components --
import { CardType2Component } from 'app/modules/jc3/components/card-type-2/card-type-2.component';
import { Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-step-2',
    standalone: true,
    imports: [CommonModule, CardType2Component, MatIconModule, FormsModule],
    templateUrl: './step-2.component.html',
    styleUrl: './step-2.component.scss',
})
export class Step2Component implements OnInit {
    @Input() products: any[] = [];
    @Input() data: any = {};
    flatProducts: any[] = [];
    filteredFlatProducts: any[] = [];
    searchText: string = '';
    dataFound: boolean = true;
    resultCountText: string = '';
    gaPrefix = 'grants_schemes_apply_';

    ngOnInit() {
        if (this.products?.length) {
            this.flatProducts = this.products.map((card) => ({
                image:
                    card?.imagedesktop ||
                    card?.logo_url ||
                    card?.mediaFileStores?.at(0)?.s3url,
                title: card?.institution || card?.title || 'Title',
                description: card?.description || 'Description',
                url: card?.url,
                buttonText: card?.CTA,
            }));

            // initially show all
            this.filteredFlatProducts = [...this.flatProducts];
        }
    }

    onSearch(): void {
        const text = this.searchText?.trim().toLowerCase() || '';

        if (!text) {
            this.filteredFlatProducts = [...this.flatProducts];
            return;
        }

        this.filteredFlatProducts = this.flatProducts.filter(
            (product) =>
                (product.title || '').toLowerCase().includes(text) ||
                (product.description || '').toLowerCase().includes(text)
        );
        const count = this.filteredFlatProducts.length;
        this.dataFound = count > 0;
        this.resultCountText = !this.dataFound
            ? 'No results found'
            : `${count} result${count > 1 ? 's' : ''} found`;
    }

    openLink(url: string) {
        if (url) {
            window.open(url, '_blank');
        }
    }
}
